import { User } from '@/types/user.type'
import { UserAddress } from '@/types/user-address.type'

import { Product } from '../products/product.types'

// Order status enum ตาม PRD
export enum OrderStatus {
  ALL = 'All',
  PENDING = 'pending', // รอชำระเงิน
  PAYMENT = 'payment', // ชำระเงินแล้ว
  COMPLETED = 'completed', // สำเร็จ ตรวจสอบสลิปแล้ว
  CANCEL = 'cancel', // ยกเลิก
}

export enum ShippingStatus {
  ALL = 'All',
  PENDING = 'pending', // รอจัดส่ง
  SHIPPED = 'shipped', // จัดส่งแล้ว
  DELIVERED = 'delivered', // ส่งสินค้าแล้ว
  CANCELLED = 'cancelled', // ยกเลิก
}

// Order priority levels
// export enum OrderPriority {
//   LOW = 'LOW',
//   MEDIUM = 'MEDIUM',
//   HIGH = 'HIGH',
//   URGENT = 'URGENT',
// }

// ข้อมูลสินค้าในออเดอร์
export interface OrderItem {
  id: string

  /** รหัสของตะกร้าที่รายการนี้อยู่ */
  cartId: string

  /** รหัสของสินค้า */
  productId: string

  /** จำนวนสินค้าที่เลือก */
  quantity: number

  /** ราคาต่อชิ้นของสินค้า */
  price: number

  /** ส่วนลดของสินค้า (เป็นจำนวนเงิน) */
  discount: number

  /** วันที่สร้างรายการ */
  createdAt: Date

  /** วันที่อัพเดทรายการล่าสุด */
  updatedAt: Date

  product?: Product
}

// ข้อมูลผู้สั่งซื้อ
export interface OrderCustomer {
  id: string
  firstName: string
  lastName: string
  displayName?: string
  email: string
  phone: string
  address?: string
}

// ข้อมูลการจัดส่ง
export interface OrderShipping {
  method: string
  trackingNumber?: string
  estimatedDelivery?: string
  shippingCost: number
  address: {
    street: string
    city: string
    province: string
    postalCode: string
    country: string
  }
}

// ข้อมูลการชำระเงิน
export interface OrderPayment {
  method: string // "credit_card", "bank_transfer", "cod", etc.
  status: 'pending' | 'paid' | 'failed' | 'refunded'
  amount: number
  paidAt?: string
  transactionId?: string
}

// Order main interface
export interface Order {
  /** รหัสของ order */
  id: string

  /** หมายเลข order */
  orderNumber: string

  /** รหัสของผู้สั่ง */
  userId: string

  /** ชื่อผู้สั่ง */
  userName?: string

  /** อีเมลผู้สั่ง */
  userEmail?: string

  /** เบอร์โทรผู้สั่ง */
  userPhone?: string

  /** รหัสร้านค้า */
  shopId?: string

  /** ชื่อร้านค้า */
  shopName?: string

  /** รหัสตะกร้าที่ใช้สร้าง order */
  cartId: string

  /** รายการสินค้าใน order */
  items: OrderItem[]

  /** ราคารวมก่อนหักส่วนลด */
  totalAmount: number

  /** ส่วนลดรวม */
  discount: number

  /** ราคาสุทธิที่ต้องชำระ */
  finalAmount: number

  /** ชื่อธนาคาร */
  bankName?: string

  /** ชื่อบัญชีธนาคารของผู้ใช้ */
  bankAccountName?: string

  /** หมายเลขบัญชีธนาคารของผู้ใช้ */
  bankAccountNumber?: string

  /** รหัสคูปองที่ใช้ */
  userCouponId?: string

  /** ส่วนลดจากคูปอง */
  userCouponDiscount?: number

  /** สถานะของ order */
  status: OrderStatus

  /** รูปหลักฐานการชำระเงิน */
  paymentProof?: string

  /** รหัสที่อยู่จัดส่ง */
  userAddressId?: string

  /** ที่อยู่จัดส่ง */
  userAddress?: UserAddress

  /** ค่าจัดส่ง */
  shippingFee?: number

  /** สถานะการจัดส่ง */
  shippingStatus: ShippingStatus

  /** หมายเหตุการจัดส่ง */
  shippingNote?: string

  /** รหัสติดตามพัสดุ */
  trackingNumber?: string

  /** วันที่จัดส่ง */
  shippedAt?: Date

  /** วันที่จัดส่งเสร็จ */
  deliveredAt?: Date

  /** หมายเหตุเพิ่มเติม */
  note?: string

  /** หมายเหตุจากการยืนยันการชำระเงิน */
  confirmationNote?: string

  /** วันที่ยืนยันการชำระเงิน */
  confirmedAt?: Date

  /** วันที่สร้าง order */
  createdAt: Date

  /** วันที่อัปเดต order ล่าสุด */
  updatedAt: Date

  /** ข้อมูลผู้สั่ง */
  customer: User

  /** ข้อมูลสินค้า (optional, for expansion) */
  product?: Product
}

// Pagination response type
export interface OrdersPaginationResponse {
  items: Order[]
  total: number
}

// Order filter types
export interface OrderFilters {
  page: number
  limit: number
  search: string // ค้นหาจากเลขที่ออเดอร์ หรือชื่อลูกค้า
  status: OrderStatus
  shippingStatus: ShippingStatus
  // priority?: OrderPriority
  dateFrom?: string
  dateTo?: string
  shopId?: string
  orderBy: string
}

// Order status update data
export interface OrderStatusUpdate {
  status: OrderStatus
  notes?: string
  trackingNumber?: string
}

// Mock data interface
export interface OrderMockData {
  orders: Order[]
  total: number
}
